import { render } from "./editContratante.vue?vue&type=template&id=7853339b&scoped=true"
import script from "./editContratante.vue?vue&type=script&lang=js"
export * from "./editContratante.vue?vue&type=script&lang=js"

import "./editContratante.vue?vue&type=style&index=0&id=7853339b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7853339b"]])

export default __exports__